import { useQuery } from '@apollo/client';
import { GET_VORLAGEN_ZUORDNUNG_OPTIONEN, ZuordnungsoptionenAntwort } from '../api/vorlagenZuordnungOptionen';

export default function useVorlagenZuordnungOptionen() {
  const { data, previousData, loading, error, refetch } = useQuery<ZuordnungsoptionenAntwort>(
    GET_VORLAGEN_ZUORDNUNG_OPTIONEN,
    { fetchPolicy: 'cache-and-network', notifyOnNetworkStatusChange: true },
  );
  const antwort = data ?? previousData;
  return {
    firmen: antwort?.getAllBranchOffice ?? [],
    vertragsarten: antwort?.getAllContractTypes ?? [],
    laedt: loading,
    fehler: !loading && (!!error || !data?.getAllBranchOffice || !data?.getAllContractTypes),
    erneutLaden: () => {
      refetch().catch(() => undefined);
    },
  };
}
